export const STORAGE_KEY = {
  ACCESS_TOKEN: "access_token",
  REFRESH_TOKEN: "refresh_token",
  PLATFORM: "platform",
  EXPIRE_ACCESS_TOKEN: "expire_access_token",
  APTOS_WALLET_NAME: "AptosWalletName",
};

export const QUERY_KEY = {
  ME: "me",
  USERS: "users",
  POOLS: "pools",
  IDLE_EVM_USERS: "idle_evm_users",
  IDLE_APTOS_USERS: "idle_aptos_users",
  TRANSACTIONS_HISTORY: "transactions_history",
  CAMPAIGN_INFO: "campaign_info",
  SPIN_TIER: "spin_tier",
  CAMPAIGN_ANALYTICS: "campaign_analytics",
  CAMPAIGN_PERFORMANCE: "campaign_performance",
  USER_STATISTICS: "user_statistics",
};
